import { Component, OnInit } from '@angular/core';
import { RoleEnum } from '@app/shared/enum/role.enum';
import { TradeInSytemCollection } from '@app/shared/models/tradein-system.collection';

@Component({
  selector: 'app-ips',
  template: ` <app-home [tradinSystemName]="tradinSytem.label" [buttons]="buttons"></app-home> `,
  styles: [],
})
export class IpsComponent {
  tradinSytem = TradeInSytemCollection.find((t) => t.role === RoleEnum.IPS);
  buttons = [
    {
      icon: 'collections_bookmark',
      label: 'Triagem',
      color: '#003B71',
      route: 'triagem/buscar',
    },
    {
      icon: 'description',
      label: 'Trades',
      color: '#FF6600',
      route: 'pedidos',
    },
    /*     {
    icon: 'icon-finance-03',
    label: 'Precificação',
    color: '#64366B',
    route: 'precificacao',
  },*/
  ];
}
